module.exports = __webpack_public_path__ + "img/MEAL.de01531a.png";